import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext, useRef } from 'react';

export const TooltipAnalytics = eventName => {
  const { trackEvent } = useContext(AnalyticsContext);
  const hasTooltipEventFired = useRef(false);
  const timeout = useRef(null);

  return () => {
    if (!hasTooltipEventFired.current) {
      trackEvent('Conditional tile - viewed tooltip', { tile: eventName });
      hasTooltipEventFired.current = true;
    }

    if (timeout.current) {
      clearTimeout(timeout.current);
      timeout.current = null;
    }

    if (hasTooltipEventFired.current && !timeout.current) {
      timeout.current = setTimeout(() => {
        hasTooltipEventFired.current = false;
      }, 1500);
    }
  };
};
